import { useEffect, useState } from "react";
import { PageableTableProvider } from "../../../../context/PageableTableContext";
import DashboardSection from "./DashboardSection";
import { IntegraionLogs } from "./IntegraionLogs";
import useAxios from "../../../../utils/useAxios";

export default function MpnDashboard() {
    const axios = useAxios();

    const [errorData, setErrorData] = useState([]);

  const fetchErrors = async () => {
    const response = await axios.get("mpn/integration-error-logs");

    setErrorData(response.data.data);
  };

  useEffect(() => {
    fetchErrors();
  }, []);


  return (
    <>
      <h6 className="text-primary fw-bold card-header border-0 mb-2">
        Dashboard
      </h6>
      <div className="mb-3">
        <PageableTableProvider>
          <DashboardSection />
        </PageableTableProvider>
      </div>

      <PageableTableProvider>
        <IntegraionLogs error={errorData} />
      </PageableTableProvider>
    </>
  );
}
